import { InputGroup, Form, DropdownButton, Dropdown, Button } from 'react-bootstrap';
import C4FInfoButton from './C4FInfoButton';
import { useState } from 'react';


function C4FReferenceDataSelection(props) {

  const [filter, setFilter] = useState(props.filter ?? '');
  
  return (
    <InputGroup className={props.className}>
      {'info' in props ?
        <C4FInfoButton title={'displayName' in props ? props.displayName : props.name} text={props.info} />
        : null
      }
      <InputGroup.Text>{'displayName' in props ? props.displayName : props.name}</InputGroup.Text>
      {props.useFilter ? 
        <Form.Control
          onChange={(e) => setFilter(e.target.value)}
          value={filter} />
        :
        <Form.Control disabled
          placeholder={'displayName' in props ? props.displayName : props.name}
          value={props.value} />
      }
      <DropdownButton 
        disabled={'disabled' in props ? props.disabled : false}
        variant={'outline-secondary'}
        size="sm"
        title={props.value === '' ? ('displayName' in props ? props.displayName : props.name) : props.value}
        onSelect={(newValue, e) => props.updateMethod(props.name, newValue)}>
        {
          props.referenceDataValues
            .filter(value => typeof value === 'string' ? 
              (filter !== '' ? value.toLowerCase().match(filter.toLowerCase()) : true) 
              : 
              (filter !== '' ? value.value.toLowerCase().match(filter.toLowerCase()) : true))
            .map(value =>
              typeof value === 'string' ? 
                <Dropdown.Item key={value} eventKey={value}>{value}</Dropdown.Item>
                :
                <Dropdown.Item key={value.key} eventKey={value.key}>{value.value}</Dropdown.Item>)
        }
      </DropdownButton>
      { props.validationMethod ?
        (props.validationMethod(props.name) ?
          <Button variant={'success'} disabled >{'\u2713'}</Button>
          :
          <Button variant={'warning'} disabled >{'!'}</Button>)
        : null  
      }
      {props.status}
    </InputGroup>
  );
}

export default C4FReferenceDataSelection;